// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { App } from './components/App';
import './styles.less';

ReactDOM.render(<App />, document.getElementById('root'));
